import React from 'react';

import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import ProgressBar from 'react-bootstrap/ProgressBar';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Nav from 'react-bootstrap/Nav';

import {
    CMD_VARIABLE,
    CMD_TABLE,
    CMD_SYSTEM,
    CMD_VARIABLE_ACTION,
    CMD_TABLE_ACTION,
    CMD_SYSTEM_ACTION,
    SYSTEM_COMMANDS,
} from '@appblocks/frontend/client/Components/DeviceDashboard/constants';


// eslint-disable-next-line import/prefer-default-export

/* FRONTEND_START_MARKER */


class SystemPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            uploading: false,
            totalProgress: 0,
            activeTab: 'commands',
        };

        this.fileInput = React.createRef();
        this.handleSubmit = this.handleSubmit.bind(this);
        this.reboot = this.reboot.bind(this);
        this.initializeSettings = this.initializeSettings.bind(this);
    }

    componentDidMount() {
        if (this.progressTimer !== undefined) {
            clearInterval(this.progressTimer);
        }
        this.progressTimer = setInterval(() => {
            if (!this.state.uploading) {
                return;
            }
            this.props.runCommand(CMD_SYSTEM, CMD_SYSTEM_ACTION.GET_FIRMWARE_UPLOAD_PROGRESS)
                .then(
                    (result) => {
                        this.setState({
                            totalProgress: result,
                        });
                    },
                    (error) => {
                        console.log(error);
                    },
                );
        }, 3000);
    }

    componentWillUnmount() {
        if (this.progressTimer !== undefined) {
            clearInterval(this.progressTimer);
        }
        this.progressTimer = undefined;
    }

    handleSubmit(event) {
        event.preventDefault();
        if (this.fileInput.current.files.length === 0) {
            alert('Please select a file');
            return;
        }
        const file = this.fileInput.current.files[0];
        const requestOptions = {
            method: 'POST',
            body: file,
        };
        this.setState({
            uploading: true,
            totalProgress: 0,
        });
        this.props.runCommand(CMD_SYSTEM, CMD_SYSTEM_ACTION.POST_FIRMWARE_UPLOAD, requestOptions)
            .then(
                (result) => {
                    this.setState({
                        uploading: false,
                    });
                    alert('Upload Completed');
                },
                (error) => {
                    this.setState({
                        uploading: false,
                    });
                    alert('Error uploading', error);
                    console.error(error);
                },
            );
    }

    sendCommand(cmd) {
        this.props.runCommand(CMD_SYSTEM, CMD_SYSTEM_ACTION.SEND_COMMAND, {
            cmd,
        });
    }

    reboot() {
        if (window.confirm('Reboot Device?')) {
            this.sendCommand(SYSTEM_COMMANDS.REBOOT);
            alert('Device will now reboot');
        }
    }

    initializeSettings() {
        if (window.confirm('Initializing settings will set values to default. Continue?')) {
            this.sendCommand(SYSTEM_COMMANDS.INITSTTINGS);
        }
    }


    render() {
        return (
            <div>
                <h2>System</h2>
                <Nav variant="tabs" activeKey={this.state.activeTab} onSelect={e => this.setState({ activeTab: e })}>
                    <Nav.Item>
                        <Nav.Link eventKey="commands">Commands</Nav.Link>
                    </Nav.Item>
                    {
                        this.props.firmwareUploadEnabled && (
                            <Nav.Item>
                                <Nav.Link eventKey="firmware">Upload Firmware</Nav.Link>
                            </Nav.Item>
                        )
                    }
                </Nav>
                <div
                    className="bg-white"
                    style={{
                        padding: '15px',
                        border: '1px solid #dee2e6',
                        borderTop: '0',
                    }}
                >
                    {this.state.activeTab === 'commands' && (
                        <>
                            <Row>
                                <Col className="py-1 mb-2">
                                    <Button onClick={this.reboot} variant="secondary">Reboot Device</Button>
                                    &nbsp;
                                    <Button onClick={this.initializeSettings} variant="secondary">Initialize Settings</Button>
                                </Col>
                            </Row>
                        </>
                    )}
                    {this.state.activeTab === 'firmware' && (
                        <>
                            <p>Upload a new firmware file (.tcu) to the Device</p>
                            <p><a href="https://apps.tibbo.com/tc_generator/" target="_blank" rel="noreferrer">You can generate a .tcu file here</a></p>
                            <Form onSubmit={this.handleSubmit}>
                                <Form.Control type="file" accept=".tcu" ref={this.fileInput} />
                                <Button type="submit" variant="primary" className="mt-2" disabled={this.state.uploading}>
                                    {this.state.uploading ? 'Uploading...' : 'Upload'}
                                </Button>
                                <br />
                                <br />
                                {this.state.uploading && (
                                    <ProgressBar variant="primary" now={this.state.totalProgress} label={`${this.state.totalProgress}%`} />
                                )}
                            </Form>
                        </>
                    )}
                </div>
            </div>
        );
    }
}

export default SystemPage;
